import { render, staticRenderFns } from "./message-page.vue?vue&type=template&id=69065d9c&scoped=true&"
import script from "./message-page.vue?vue&type=script&lang=js&"
export * from "./message-page.vue?vue&type=script&lang=js&"
import style0 from "./message-page.vue?vue&type=style&index=0&id=69065d9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69065d9c",
  null
  
)

export default component.exports